(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[725],{

/***/ 7590:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[wpTag]",
      function () {
        return __webpack_require__(733);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppFooter */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);



var AppFooter = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "footer_container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "footer_about",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "about_us",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "about_logo",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                src: "/images/boom_logo.png",
                                alt: "Boom logo",
                                layout: "fill",
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "about_info",
                            children: "Copyright \xa9 2021, BoomTV"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "about_links",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/terms",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Terms and Conditions"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Privacy"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/about",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "About"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/personal-data",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Do Not Sell My Personal Information"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppFooter);


/***/ }),

/***/ 9735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5617);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var contexts_app_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6777);
/* harmony import */ var contexts_viewport__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(369);
/* harmony import */ var redux_global_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3663);
/* harmony import */ var redux_event_lobby_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8279);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3135);












function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var AppHeader = function(param) {
    var _transparent = param.transparent, transparent = _transparent === void 0 ? false : _transparent;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)().asPath;
    var ref = (0,contexts_viewport__WEBPACK_IMPORTED_MODULE_8__/* .useViewport */ .Sj)(), isTwoColumnView = ref.isTwoColumnView, width = ref.width;
    var ref1 = _slicedToArray((0,contexts_app_context__WEBPACK_IMPORTED_MODULE_7__/* .useAppContext */ .b)(), 2), state = ref1[0], configDispatch = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isScrolling = ref2[0], setIsScrolling = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowingHamburger = ref3[0], setIsShowingHamburger = ref3[1];
    var currentScreen = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_global_slice__WEBPACK_IMPORTED_MODULE_9__/* .selectors.currentScreen */ .wl.currentScreen);
    var eventTitle = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_event_lobby_slice__WEBPACK_IMPORTED_MODULE_10__/* .selectors.eventTitle */ .wl.eventTitle);
    var goToHomePage = function() {
        window.location.href = '/';
    };
    var confirmGoToHomePage = function() {
        if (currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.EventLobby */ .wc.EventLobby || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay) {
            configDispatch({
                type: 'SET_CONFIRM_MESSAGE',
                payload: 'Are you sure you want to return to the home page?'
            });
            configDispatch({
                type: 'SHOW_MODAL_CONFIRM',
                payload: true
            });
            configDispatch({
                type: 'SET_CONFIRM_ACTION',
                payload: goToHomePage
            });
        }
    };
    var showModalJoinOuting = function() {
        configDispatch({
            type: 'SHOW_MODAL_JOIN_OUTING',
            payload: true
        });
    };
    var isEventTitleVisible = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return currentScreen && currentScreen !== utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.Landing */ .wc.Landing && (isTwoColumnView || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay);
    }, [
        isTwoColumnView,
        currentScreen
    ]);
    var toggleNavHamburger = function() {
        setIsShowingHamburger(!isShowingHamburger);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleScroll = function(e) {
            var offset = window.pageYOffset || document.documentElement.scrollTop;
            if (offset > 0) {
                setIsScrolling(true);
            } else {
                setIsScrolling(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var isWhiteNavbar = !transparent || isScrolling || isShowingHamburger;
    var isSmallLogoNeeded = (eventTitle === null || eventTitle === void 0 ? void 0 : eventTitle.length) > 20 && width < 650 && currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: 'nav_header' + (isWhiteNavbar ? ' white' : ''),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container nav_header_inner",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "block_left",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('header_logo', {
                                    small: isSmallLogoNeeded
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    passHref: true,
                                    href: currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.EventLobby */ .wc.EventLobby || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay ? 'javascript:void(0)' : '/',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                        src: isSmallLogoNeeded ? '/images/modal_logo.png' : isWhiteNavbar ? '/images/header/logo_white.png' : '/images/header/logo.png',
                                        alt: "Logo",
                                        layout: "fill",
                                        objectFit: "contain",
                                        onClick: confirmGoToHomePage
                                    })
                                })
                            }),
                            isEventTitleVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "nav_logo_text",
                                children: isSmallLogoNeeded ? "".concat(eventTitle.slice(0, 16), "...") : eventTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "block_right",
                        children: width > 650 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "nav_menu_container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/help-details",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Help & Details"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/contact-us",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Contact"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "nav_button",
                                        onClick: showModalJoinOuting,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "Create Now"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "arrow_button"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "nav_menu_container",
                            children: isWhiteNavbar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                src: "/images/header/hamburger_grey.png",
                                alt: "Hamburger",
                                width: 27,
                                height: 23,
                                onClick: toggleNavHamburger
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                src: "/images/header/hamburger.png",
                                alt: "Hamburger",
                                width: 27,
                                height: 23,
                                onClick: toggleNavHamburger
                            })
                        })
                    })
                ]
            }),
            width <= 650 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: 'nav_mobile_menu' + (isShowingHamburger ? ' show' : ''),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_shadow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            href: "/help-details",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Help & Details"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            href: "/contact-us",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Contact"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_button",
                        onClick: showModalJoinOuting,
                        children: "Create Now"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppHeader);


/***/ }),

/***/ 2053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconArrowNext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var IconArrowNext = function(param) {
    var _color = param.color, color = _color === void 0 ? '#FFFFFF' : _color;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "9",
        height: "15",
        viewBox: "0 0 9 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.98836 0.292893L8.35232 6.65685C8.74284 7.04738 8.74284 7.68054 8.35232 8.07107L1.98836 14.435C1.59783 14.8256 0.964668 14.8256 0.574143 14.435C0.183619 14.0445 0.183619 13.4113 0.574143 13.0208L5.231 8.36396L6.14551 7.36396L5.231 6.36396L0.574143 1.70711C0.183619 1.31658 0.183619 0.683418 0.574143 0.292893C0.964668 -0.0976311 1.59783 -0.0976311 1.98836 0.292893Z",
            fill: color
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconArrowNext);


/***/ }),

/***/ 733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "Listing": function() { return /* binding */ Listing; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var contexts_viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(369);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_app_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9735);
/* harmony import */ var components_app_footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2695);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3135);
/* harmony import */ var utils_dayjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2869);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1664);
/* harmony import */ var styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3344);
/* harmony import */ var styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5675);
/* harmony import */ var _components_icon_arrow_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2053);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7294);













var Tag = function(param) {
    var tag = param.tag;
    if (!(tag === null || tag === void 0 ? void 0 : tag.slug)) {
        return null;
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_8__["default"], {
        href: "".concat(utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .wpRoutePrefix */ ._e, "/").concat(tag.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "description_medium ".concat((styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tags)),
            children: tag.slug
        })
    }));
};
var __N_SSG = true;
var Listing = function(param1) {
    var posts = param1.posts, tags = param1.tags, authors = param1.authors, wpTag = param1.wpTag;
    var mainTag = Object.values(tags).find(function(param) {
        var slug = param.slug;
        return slug === wpTag;
    });
    var isMobile = (0,contexts_viewport__WEBPACK_IMPORTED_MODULE_2__/* .useViewport */ .Sj)().isMobile;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(''), keySearch = ref[0], setKeySearch = ref[1];
    var handleKeyDown = function(event) {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    var handleChangeKeySearch = function(event) {
        var value = event.target.value;
        setKeySearch(value.trim());
    };
    var handleSearch = function() {
        if (!keySearch) return;
        location.href = '/help-details/search?q=' + keySearch;
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "news_page",
        className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().news_page),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "".concat((0,lodash__WEBPACK_IMPORTED_MODULE_3__.startCase)(wpTag), " | Team Games Blogs")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/images/modal_logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .TeamGamesMetaDescription */ .iO
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "og:image",
                        content: utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .TeamGamesOGImagePath */ .Od
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_app_header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        transparent: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_bg),
                        children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_bg_img),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_9__["default"], {
                                src: "/images/wpTag/background_mobile.png",
                                alt: "Game for Every Team",
                                layout: "fill"
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_bg_img),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_9__["default"], {
                                src: "/images/wpTag/background.png",
                                alt: "Game for Every Team",
                                layout: "fill"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_container),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_left),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_breadcrumb),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_help),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                                href: "/help-details",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: "Help & Details"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon_arrow_next__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_wp_tag),
                                            children: wpTag.replace('-', ' ')
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_right),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_search_container),
                                    children: [
                                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_search_icon),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_9__["default"], {
                                                src: "/images/help_details/search_icon.png",
                                                alt: "Search Icon",
                                                width: 17,
                                                height: 17,
                                                onClick: handleSearch
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_search_border)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_search_input),
                                            placeholder: "Search FAQ, Announcements, etc...",
                                            onKeyDown: handleKeyDown,
                                            onChange: handleChangeKeySearch
                                        }),
                                        isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header_search_icon_mobile),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_9__["default"], {
                                                src: "/images/help_details/search_icon_mobile.png",
                                                alt: "Search Icon",
                                                layout: "fill",
                                                onClick: handleSearch
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().container),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat((styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().main_content), " col-md-8"),
                    children: posts.map(function(post, postIndex) {
                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().post),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
                                            tag: mainTag
                                        }),
                                        post.tags.filter(function(id) {
                                            return id !== (mainTag === null || mainTag === void 0 ? void 0 : mainTag.id);
                                        }).sort(function(a, b) {
                                            if (tags[a].slug > tags[b].slug) return 1;
                                            if (tags[a].slug < tags[b].slug) return -1;
                                            return 0;
                                        }).map(function(id) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
                                                tag: tags[id]
                                            }, id);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                    href: "".concat(utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .wpRoutePrefix */ ._e, "/").concat(wpTag, "/[slug]"),
                                    as: "".concat(utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .wpRoutePrefix */ ._e, "/").concat(wpTag, "/").concat(post.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "hero",
                                            dangerouslySetInnerHTML: {
                                                __html: post.title.rendered
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "description_medium",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: "By ".concat(authors[post.author].name, " | ").concat((0,utils_dayjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(post.date).format('MM/DD/YYYY'))
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "description_medium ".concat((styles_blogListing_module_scss__WEBPACK_IMPORTED_MODULE_12___default().description)),
                                    dangerouslySetInnerHTML: {
                                        __html: post.excerpt.rendered.replace('[&hellip;]', '&hellip;')
                                    }
                                })
                            ]
                        }, postIndex));
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_app_footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Listing);


/***/ }),

/***/ 2869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8734);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_objectSupport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5069);
/* harmony import */ var dayjs_plugin_objectSupport__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_objectSupport__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6176);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7__);








dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_objectSupport__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7___default()));
/* harmony default export */ __webpack_exports__["Z"] = ((dayjs__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ }),

/***/ 3344:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_section":"blogListing_header_section__jfHyz","header_bg":"blogListing_header_bg__7I_h_","header_bg_ep":"blogListing_header_bg_ep__d0YOa","header_bg_img":"blogListing_header_bg_img__YfnjH","header_container":"blogListing_header_container__ckoLK","header_left":"blogListing_header_left__LTDDE","header_breadcrumb":"blogListing_header_breadcrumb__GOwXq","header_help":"blogListing_header_help__q8tQq","header_wp_tag":"blogListing_header_wp_tag__FSH1p","header_right":"blogListing_header_right__iKFSm","header_search_container":"blogListing_header_search_container__TSK_Z","header_search_icon":"blogListing_header_search_icon__YJyhn","header_search_border":"blogListing_header_search_border__A4HcX","header_search_input":"blogListing_header_search_input__ZNCTY","container":"blogListing_container__ypnrg","post":"blogListing_post__LqeEd","main_content":"blogListing_main_content__Znapp","content_body":"blogListing_content_body__mAnar","tags":"blogListing_tags__hRzgv","description":"blogListing_description__siWnG","title":"blogListing_title__hsrev","header_search_icon_mobile":"blogListing_header_search_icon_mobile__VUMJe"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,78,969,774,888,179], function() { return __webpack_exec__(7590); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);